import InputField from "../../../components/common/form/InputField";
import React, { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import { OptionType } from "../../../helpers/utils/StyleUtils";
import Form from "../../../components/common/form/Form";
import { useGetAllTenantsQuery } from "../../customer/tenantApi";
import { createOptionListForSelectTag } from "../../../helpers/utils/Utils";
import SelectField from "../../../components/common/form/SelectField";
import { useNavigate, useParams } from "react-router-dom";
import {
    useGetAllFulfillmentCustomerByTenantQuery,
    useLazySearchCustomersQuery
} from "../../customer/customerApi";
import { handleRTKQuery } from "../../../helpers/utils/RtkQueryUtils";
import { useCreateTeamMutation, useGetTeamByIdQuery, useSearchUserTeamsQuery, useUpdateTeamMutation } from "./teamsApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { Routes as AppRoutes } from "../../../routes";

import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import ButtonTray from "../../../components/common/form/ButtonTray";
import Breadcrumb, { Crumb } from "../../../components/common/Breadcrumbs";
import AuditableInfoButton from "../../../components/common/form/AuditableInfoButton";
import { FaSearch, FaTimes } from "react-icons/fa";
import { useGetEnumsQuery } from "../../../app/globalApi";
import AddManagerForm from "../../../components/common/form/AddManagerModal";
import IconButton from "../../../components/common/form/IconButton";
import ModalButton from "../../../components/common/form/ModalButton";
import CommonSelectorModal from "../../../components/common/form/CommonSelectorModal";
import { useSearchUsersQuery } from "../users/usersApi";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import Preloader from "../../../components/common/Preloader";

interface props {
    crumbs: Crumb[];
    title: string,
    btnText?: string,
    isEditable?: boolean
}


const TeamForm: FC<props> = ({ crumbs, title, btnText, isEditable }) => {

    const { teamId } = useParams();

    const navigate = useNavigate();
    const tenantData = useGetAllTenantsQuery("");
    const [teamData, setTeamData] = useState<any>({});
    const [searchCustomer, customerData] = useLazySearchCustomersQuery();
    const [createTeamApi, createTeamApiResponse] = useCreateTeamMutation();
    const [updateTeamApi, updateTeamApiResponse] = useUpdateTeamMutation();
    const teamByIdQuery = useGetTeamByIdQuery(teamId ?? skipToken);
    const { data: enums } = useGetEnumsQuery("");
    const [manager, setManager] = useState(null);
    const [showAddManager, setShowAddManager] = useState(false);
    const fulfillmentcustomer = useGetAllFulfillmentCustomerByTenantQuery(teamData?.tenant?.value)
    const iconButtonStyle = "fa cursor-pointer text-highlight-0 absolute left-auto right-5 top-6";
    const [selectedRowData, setSelectedRowData] = useState<any>({});
    const [customerId, setCustomerId] = useState<any>("");
    const [username, setUsername] = useState<any>("");
    const [selectedRow, setSelectedRow] = useState<any>({});

    useEffect(() => {
        if (teamData?.tenantId) {
            searchCustomer({
                pageSize: 100,
                tenantId: teamData?.tenantId?.value,
            });
        }
    }, [teamData?.tenantId]);

    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | null }) => {
        const { name, value } = "target" in e ? e.target : e;
        setTeamData({
            ...teamData,
            [name]: value,
        })
    };

    useEffect(() => {
        let obj = teamByIdQuery?.data;
        if (obj) {
            setUsername(obj.data.usernme)
            setTeamData({
                ...obj,
                tenantId: {
                    label: tenantData?.data?.filter((el: any) => el.id === obj?.tenantId)?.[0]?.name,
                    value: obj.tenantId
                },
                customerId: {
                    value: obj.customerId, label: customerData?.data?.data.filter((el: any) => {
                        return el.id === obj.customerId
                    })[0]?.customerName
                },
                permittedCustomers: obj.permittedCustomers?.map((el: any) => {
                    let customer = customerData?.data?.data?.filter((pl: any) => {
                        return pl.id === el
                    })[0];
                    if (customer) {
                        return { label: customer?.customerName, value: customer?.id }
                    }
                })
            })
        }
    }, [teamByIdQuery?.data, customerData?.data, tenantData?.data]);


    const handleToggle = (property: string) => (e: any) => {

        setTeamData((prevData: any) => ({
            ...prevData,
            [property]: !prevData[property]
        }));
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        let obj = {
            tenant: teamData?.tenant?.value,
            customerId: customerId,
            permittedCustomers: (!teamId || !teamData?.permitAllSubordinateCustomers)
                ? teamData?.permittedCustomers?.map((el: any) => el?.value)
                : [],
            teamName: teamData?.teamName,
            username: username
        };

        const createOrUpdateUser = async () => {
            if (!teamId) {
               return  await createTeamApi(obj).unwrap();
            } else {
               return  await updateTeamApi({
                    id: teamId,
                    requestBody: obj,
                }).unwrap();
            }
        };

        await handleRTKQuery(createOrUpdateUser, (response) => {
             if (response?.success || response?.data?.success) {
                setTeamData({});
                navigate(AppRoutes.Teams.path);
            }
        });

    }
    let customFilter: Record<string, any> = {
        teamParam: "Is_MANAGER_SEARCH_PARAM",
        tenant: teamData?.tenant?.value,
    };

    if (teamData?.customerName?.value !== null) {
        customFilter.customerId = teamData?.customerName?.value;
    }


    const selectUser = (props: any) => (
        <span className="active cursor" id={`${props.row.original.id}1`}>
            {props.value}
        </span>
    );

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "username",
            cell: (props: any) => selectUser(props),
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "username",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''} />
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "username"
            }],
        },
        { label: "Email", accessor: "email" },
        { label: "Customer", accessor: "customer.customerName", canSort: false },
    ]

    const handleOnClick = (e: any, name: string) => {
        e.preventDefault();
        setUsername(selectedRow?.username)
        setShowAddManager(false)
    }


    return (
        <>

            <div className="px-4 py-2">

                <div className={"justify-between sm:block md:flex lg:flex"}>
                    <Breadcrumb crumbs={crumbs} />
                    { hasPermission( ["AUDIT-V"]) &&
                        <AuditableInfoButton obj={teamData?.data} />
                    }
                </div>

                <div className="flex justify-center mt-3">
                    <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                        <h3 className="text-xl font-semibold text-surface-0 pb-3 border-b border-surface-7">{title}</h3>
                        <Form onSubmit={handleSubmit} fields={<>
                            <div className="grid grid-cols-12 text-sm">
                                <InputField
                                    name={"teamName"}
                                    label="Name"
                                    onChange={handleOnChange}
                                    value={teamData?.teamName || ""}
                                    type="text"
                                    placeholder="Enter Team Name..."
                                    required={true}
                                />
                                <SelectField
                                    placeholder='Select Tenant...'
                                    value={teamData?.tenant}
                                    options={createOptionListForSelectTag(tenantData?.data, "name", "name")}
                                    onChange={(selectedOption) => {
                                        handleOnChange({ name: "tenant", value: selectedOption })
                                    }}
                                    label={"Tenant"}
                                    required={true}
                                />
                                <SelectField
                                    placeholder='Select FulFillment Customers...'
                                    value={teamData?.fulFillment}
                                    options={createOptionListForSelectTag(fulfillmentcustomer?.data, "customerName", "id")}
                                    onChange={(selectedOption) => {
                                        handleOnChange({ name: "customerName", value: selectedOption })
                                        setCustomerId(selectedOption?.value)
                                    }}
                                    label={"FulFillment Customers"}
                                />
                                {teamData?.customerName && (
                                    <InputField
                                        name="username"
                                        label="Leader"
                                        onChange={handleOnChange}
                                        value={username || ""}
                                        type="text"
                                        required
                                        placeholder="Select Leader..."
                                        onClick={() =>
                                            setShowAddManager(true)
                                        }
                                        className="cursor-pointer"
                                        inputIcon={
                                            username ? (
                                                <FaTimes
                                                    className={iconButtonStyle}
                                                    title="Clear Data"
                                                    onClick={() => {
                                                        setUsername(null);
                                                    }}
                                                />
                                            ) :
                                                <FaSearch
                                                    className={iconButtonStyle}
                                                    title="Add Provider Detail"
                                                    onClick={() => {
                                                        setShowAddManager(true);
                                                    }}
                                                />
                                        }
                                    />
                                )}
                            </div>
                            <div className="col-span-12 md:grid md:grid-cols-12 gap-3">
                                <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                </div>
                                <div className="relative col-span-9">
                                    <div className={"mt-4 flex"}>
                                        <ButtonTray
                                            buttons={[
                                                {
                                                    buttonProps: {
                                                        btnText: "Cancel",
                                                        onClick: () => navigate(AppRoutes.Teams.path),
                                                        type: "cancel",
                                                    },
                                                    buttonType: "button"
                                                },
                                                {
                                                    buttonProps: {
                                                        btnText: "Submit",
                                                        type: "submit",
                                                        isLoading: (createTeamApiResponse.isLoading || updateTeamApiResponse.isLoading),
                                                        isVisible: isEditable
                                                    },
                                                    buttonType: "button",

                                                }
                                            ]}
                                            align="center"
                                            gap={2}
                                        />
                                    </div>
                                </div>
                            </div>



                        </>}
                        />
                    </div>
                </div>
                {showAddManager &&
                    <CommonSelectorModal
                        title="Team Leader Selector"
                        columns={columns}
                        data={useSearchUsersQuery}
                        show={showAddManager}
                        onSubmit={handleOnClick}
                        setShow={setShowAddManager}
                        setSelectedRow={setSelectedRow}
                        customerFilter={customFilter}
                    />

                }
            </div>
        </>
    )
}
export default TeamForm;